class CarouselFiftyFifty extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick.bind(this))
    })

    this.updateIndex(0)
  }

  onTabClick(event) {
    const index = parseInt(event.currentTarget?.getAttribute("data-index") || "0")
    this.updateIndex(index)
  }

  updateIndex(index) {
    this.updateActiveTab(index)
    this.updateActiveText(index)
    this.updateActiveImage(index)
  }

  updateActiveTab(index) {
    this.tabs.forEach((tab) => {
      if (tab.getAttribute("data-index") != index) {
        tab.classList.remove("active")
        tab.setAttribute("aria-selected", false)
      } else {
        tab.classList.add("active")
        tab.setAttribute("aria-selected", true)
      }
    })
  }

  updateActiveText(index) {
    this.textWrappers.forEach((text) => {
      if (text.getAttribute("data-index") != index) {
        text.classList.remove("active")
      } else {
        text.classList.add("active")
      }
    })
  }

  updateActiveImage(index) {
    this.imageWrappers.forEach((text) => {
      if (text.getAttribute("data-index") != index) {
        text.classList.remove("active")
      } else {
        text.classList.add("active")
      }
    })
  }

  get tabs() {
    return this.querySelectorAll(".js-tab-item")
  }

  get textWrappers() {
    return this.querySelectorAll(".js-text-wrapper")
  }

  get imageWrappers() {
    return this.querySelectorAll(".js-image-wrapper")
  }
}

customElements.define("carousel-fifty-fifty", CarouselFiftyFifty)
